import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ElementType } from 'bom/enums';
import { Button } from 'core/components';
import { useAgGridTableContext } from 'core/states';
import { Color, Variant } from 'theme/enums';

import { SaveAsTemplate } from './SaveAsTemplate';

export const SaveAsTemplateButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const { selectedRows, deselectAllRows } = useAgGridTableContext();

  const selectedElement = useMemo(
    () => (selectedRows.length !== 1 ? null : selectedRows[0]),
    [selectedRows]
  );

  const isDisabled = useMemo(
    () =>
      !!selectedElement &&
      selectedElement.empty !== 0 &&
      ![ElementType.ID_OVERAGE, ElementType.ID_SHORTAGE].includes(selectedElement.id),
    [selectedElement]
  );

  const onSubmitSuccess = () => deselectAllRows();

  return (
    <>
      <Button
        text={t('buttonLabelSaveAsTemplate')}
        variant={Variant.OUTLINED}
        color={Color.NEUTRAL}
        onClick={() => setIsOpen(true)}
        disabled={isDisabled}
      />

      {!isDisabled && (
        <SaveAsTemplate
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          element={selectedElement}
          onSubmitSuccess={onSubmitSuccess}
        />
      )}
    </>
  );
};
